export default ({ request }) => ({
  stockSampleListApi(data = {}) {
    return request({
      url: '/samplemanage/stockSample/list',
      method: 'post',
      data
    })
  },
  stockSampleChangeLogListApi(data = {}) {
    return request({
      url: '/samplemanage/stockSample/log/list',
      method: 'post',
      data
    })
  }
})
